import { AHText, useScaleFactor } from "arkh";

import { useCallback, useEffect, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { View } from "react-native";
import { graphql, useMutation } from "react-relay";
import { useAlert } from "../../../common/Alert";
import { StoreAdminNavigationScreenProps } from "../../StoreAdmin/StoreAdminNavigation";
import { AddScreenScanQRMutation } from "./__generated__/AddScreenScanQRMutation.graphql";
import { CameraView, Camera, BarcodeScanningResult } from "expo-camera";
export const AddScreenScanQR = (
  props: StoreAdminNavigationScreenProps<"AddScreenScanQR">
) => {
  const intl = useIntl();
  const Alert = useAlert();
  const sf = useScaleFactor();

  const [hasPermission, setHasPermission] = useState(false);

  useEffect(() => {
    const getBarCodeScannerPermissions = async () => {
      const { status } = await Camera.requestCameraPermissionsAsync();
      setHasPermission(status === "granted");
    };

    getBarCodeScannerPermissions();
  }, []);

  const [register] = useMutation<AddScreenScanQRMutation>(graphql`
    mutation AddScreenScanQRMutation($deviceCode: String!, $storecastId: ID) {
      storecastInstall(deviceCode: $deviceCode, storecastId: $storecastId) {
        id
        name
        dashboard {
          id
          name
        }
        activeSession {
          id
          latencyMs
          endAt
        }
      }
    }
  `);

  const [deviceCode, setDeviceCode] = useState<null | string>(null);

  useEffect(() => {
    if (deviceCode) {
      register({
        variables: {
          storecastId: props.route.params.fromStorecast?.id,
          deviceCode,
        },
        onCompleted: (d) => {
          if (d.storecastInstall) {
            props.navigation.pop(1);
            props.navigation.replace("AddScreenSetName", {
              screenId: d.storecastInstall.id,
              fromStorecast: props.route.params.fromStorecast,
            });
          }
        },
        onError: (d) => {
          console.error(d);
          Alert.alert("Error", "Error trying to install the screen");
        },
      });
    }
  }, [
    register,
    props.route.params.fromStorecast,
    deviceCode,
    props.navigation,
    Alert,
  ]);

  const onScanned = useCallback(
    ({ data }: BarcodeScanningResult) => {
      if (data.startsWith("storeapp://storecast/add/device_code:")) {
        setDeviceCode(data.replace("storeapp://storecast/add/", ""));
      } else {
        Alert.alert(
          intl.formatMessage({
            defaultMessage: `Invalid QR-Code`,
            description: "StorcastAdminAddTV invalid qr code alert title",
          }),
          intl.formatMessage({
            defaultMessage: `We did not recognize the QR-Code that you scanned. Ensure that your TV's web browser is pointed towards storecast.app and try again.`,
            description: "StorcastAdminAddTV invalid qr code alert description",
          })
        );
      }
    },
    [setDeviceCode, Alert, intl]
  );

  if (!hasPermission) {
    return null;
  }
  return (
    <View style={{ flex: 1 }}>
      <CameraView
        style={{ width: "100%", height: "100%" }}
        barcodeScannerSettings={{
          barcodeTypes: ["qr"],
        }}
        onBarcodeScanned={onScanned}
      />

      <AHText
        type="title-small"
        color="text-inverted"
        textAlign="center"
        style={{ position: "absolute", width: "100%", top: sf * 64 }}
      >
        <FormattedMessage
          description="Storecast admin qr scanner message"
          defaultMessage="Aim the camera towards the QR-code."
        />
      </AHText>
    </View>
  );
};
